<template>
  <div class="mb-3 font-niceone-medium">{{ $t('search.popular_search') }}</div>
  <div class="flex flex-wrap gap-2">
    <div v-for="(item, index) in trends.popular_keywords" :key="`popular-search-${index}`"
         class="overflow-hidden border border-primary py-1.25 px-2.5 text-xs rounded-full cursor-pointer"
         @click="navigate(item)">
      <div class="flex gap-1">
        <niceone-image v-if="item?.hot" :src="$publicPath('/images/search/star.png')" width="16"/>
        <nuxt-link :to="$routerUrl('search/?q='+item.keyword)">
          {{ item.keyword }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import {recentSuggestionWord} from "@/composables/useStoreWord";
import {track} from "@/composables/useTrackEvent";
import {TRACKERS} from "@/constants/events";

const emit = defineEmits(['setSearch']);
defineProps({
  trends: {
    type: Object,
    default: () => ({}),
  },
});

const navigate = (item, index = 0, source_name = 'popular') => {
  track(TRACKERS.SEARCH, {item, index, source_name})
  emit('setSearch', item.keyword)
  recentSuggestionWord({term: item.keyword, search_query: item.keyword})
}
</script>
